import "../../../shared/styles/form.css";

import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import Column from "antd/lib/table/Column";
import { useState } from "react";

import { PlusCircleTwoTone } from "@ant-design/icons";

import ServiceTypeDTO from "../../../shared/dtos/serviceTypeDTO";

type Props = {
  servicePrices: any[];
  setServicePrices: any;
  serviceTypes: ServiceTypeDTO[];
};

const CreateItemsServices = ({
  servicePrices = [],
  setServicePrices,
  serviceTypes,
}: Props) => {
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const addServiceItem = (values: any) => {
    const {
      servicesDriver,
      priceService,
      additionalStopPrice,
      additionalStopDriverPrice,
      waitingMinutePrice,
      waitingMinuteDriverPrice,
      waitingGraceMinutes,
      driverPriceService,
    } = values;

    if (!servicesDriver || !priceService) {
      notification.error({
        message: "Error",
        description: "Debe seleccionar un servicio y un precio.",
        placement: "bottom",
        key: "global",
      });
      return;
    }

    const selectedService = serviceTypes.find(
      (s: any) => s.id === servicesDriver,
    );

    if (!selectedService) {
      notification.error({
        message: "Error",
        description: "Servicio inválido.",
        placement: "bottom",
        key: "global",
      });
      return;
    }

    const alreadyExists = servicePrices.some(
      (s) => s.serviceTypeId === selectedService.id,
    );

    if (alreadyExists) {
      notification.warning({
        message: "Advertencia",
        description: "Este servicio ya ha sido agregado.",
        placement: "bottom",
        key: "global",
      });
      return;
    }

    const newService = {
      serviceTypeId: servicesDriver,
      serviceType: selectedService.name,
      price: priceService,
      additionalStopPrice,
      additionalStopDriverPrice,
      waitingMinutePrice,
      waitingMinuteDriverPrice,
      waitingGraceMinutes,
      driverPrice: driverPriceService,
    };

    setServicePrices([...servicePrices, newService]);

    form.resetFields([
      "servicesDriver",
      "priceService",
      "additionalStopPrice",
      "additionalStopDriverPrice",
      "waitingMinutePrice",
      "waitingMinuteDriverPrice",
      "waitingGraceMinutes",
      "driverPriceService",
    ]);
  };

  const removeServiceItem = (serviceTypeId: number) => {
    const updatedServices = servicePrices.filter(
      (service) => service.serviceTypeId !== serviceTypeId,
    );
    setServicePrices(updatedServices);
  };

  return (
    <>
      <Modal
        open={openModal}
        title="Formulario de servicios"
        footer={null}
        onCancel={() => setOpenModal(!openModal)}
      >
        <Form
          name="basic"
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={addServiceItem}
          autoComplete="off"
          form={form}
          initialValues={{
            priceService: 0,
            driverPriceService: 0,
            additionalStopPrice: 0,
            additionalStopDriverPrice: 0,
            waitingMinutePrice: 0,
            waitingMinuteDriverPrice: 0,
            waitingGraceMinutes: 0,
          }}
        >
          <Form.Item name="servicesDriver" label="Servicios">
            <Select
              placeholder="Seleccione un servicio"
              showSearch
              options={serviceTypes.map((x) => ({
                value: x.id,
                label: x.name,
              }))}
              optionFilterProp="label"
            />
          </Form.Item>

          <Form.Item label="Precio" name="priceService">
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item label="Precio conductor" name="driverPriceService">
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item label="Precio por paradas" name="additionalStopPrice">
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item
            label="Precio por paradas conductor"
            name="additionalStopDriverPrice"
          >
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item
            label="Precio por minuto de espera"
            name="waitingMinutePrice"
          >
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item
            label="Precio por minuto de espera conductor"
            name="waitingMinuteDriverPrice"
          >
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
              min={0}
            />
          </Form.Item>

          <Form.Item
            label="Tolerancia de minutos de espera"
            name="waitingGraceMinutes"
          >
            <InputNumber<number> min={0} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Space direction="horizontal">
              <Button
                type="primary"
                htmlType="submit"
                icon={<PlusCircleTwoTone />}
              >
                Agregar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      <Row gutter={[32, 16]}>
        <Col span={24}>
          <Button
            onClick={() => setOpenModal(!openModal)}
            icon={<PlusCircleTwoTone />}
            type="primary"
          >
            Servicio
          </Button>
        </Col>

        <Col span={24}>
          <Table
            dataSource={servicePrices.map((service) => ({
              ...service,
              key: service.serviceTypeId,
            }))}
            pagination={false}
          >
            <Column
              title="Servicio"
              dataIndex="serviceType"
              key="serviceType"
            />
            <Column title="Precio" dataIndex="price" key="price" />
            <Column
              title="Precio conductor"
              dataIndex="driverPrice"
              key="driverPrice"
            />
            <Column
              title="Precio minuto espera"
              dataIndex="waitingMinutePrice"
              key="waitingMinutePrice"
            />
            <Column
              title="Precio por parada"
              dataIndex="additionalStopPrice"
              key="additionalStopPrice"
            />
            <Column
              title="Action"
              key="action"
              render={(_: any, record: any) => (
                <Space size="middle">
                  <Button
                    type="link"
                    onClick={() => removeServiceItem(record.serviceTypeId)}
                  >
                    Eliminar
                  </Button>
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default CreateItemsServices;
